import { Meta } from '@weblite-wapps/protocol'
import { generateWappElementName } from 'weblite-web-wapprunner'
import hostConf from '$config/frontend'

export const getWappDOMElement = (meta: Meta) =>
  window.document.getElementsByName(
    generateWappElementName(meta),
  )[0] as HTMLIFrameElement

export const postMessage = (element: HTMLIFrameElement, action: unknown) =>
  element.contentWindow?.postMessage(
    JSON.stringify(action),
    hostConf.WAPPS_HOST,
  )
